module.exports = __webpack_public_path__ + "img/logo-small.4a34a883.png";